document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[id^='pdp-therapy-']").forEach((section) => {
    const scroller = section.querySelector("[data-therapy-scroller]");
    const prevBtn = section.querySelector(".pdp-therapy__nav--prev");
    const nextBtn = section.querySelector(".pdp-therapy__nav--next");

    // Accordion behavior: only one open at a time (like your screenshot)
    section.querySelectorAll("[data-therapy-toggle]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const card = btn.closest("[data-therapy-card]");
        const desc = card.querySelector("[data-therapy-desc]");
        const isOpen = btn.getAttribute("aria-expanded") === "true";

        // close others
        section.querySelectorAll("[data-therapy-toggle]").forEach((otherBtn) => {
          const otherCard = otherBtn.closest("[data-therapy-card]");
          const otherDesc = otherCard.querySelector("[data-therapy-desc]");
          otherBtn.setAttribute("aria-expanded", "false");
          otherBtn.querySelector(".pdp-therapy__toggle-icon").textContent = "+";
          otherDesc.hidden = true;
        });

        // toggle current
        if (!isOpen) {
          btn.setAttribute("aria-expanded", "true");
          btn.querySelector(".pdp-therapy__toggle-icon").textContent = "−";
          desc.hidden = false;
        }
      });
    });

    // Slider buttons
    const scrollByOneCard = (dir) => {
      const firstCard = section.querySelector("[data-therapy-card]");
      if (!firstCard) return;
      const gap = parseFloat(getComputedStyle(scroller).gap || 18);
      const amount = firstCard.getBoundingClientRect().width + gap;
      scroller.scrollBy({ left: dir * amount, behavior: "smooth" });
    };

    prevBtn?.addEventListener("click", () => scrollByOneCard(-1));
    nextBtn?.addEventListener("click", () => scrollByOneCard(1));
  });
});
